import { PoliceGlobalNavFooter, policeLightTheme } from 'app/components/themes/policeTheme';

export type AgencyBranding = {
  theme: any[];
  favicon: {
    favicon: string;
    faviconType?: string;
    faviconSize?: string;
    shortcutIcon?: string;
    title: string;
  };
  logo: {
    src: string;
    alt: string;
  };
  footer: React.ReactNode;
};

const agencyBranding = {
  'NSW Police Force': {
    theme: [policeLightTheme],
    favicon: {
      favicon: './sbr-assets/agency-logos/nsw-police-force.svg',
      faviconType: 'image/svg+xml',
      faviconSize: '32x32',
      title: 'Gun Buyback Scheme | NSW Police Force',
    },
    logo: {
      src: './sbr-assets/agency-logos/nsw-police-logo.png',
      alt: 'NSW Police Force and NSW Government',
    },
    footer: PoliceGlobalNavFooter,
  },
} satisfies Record<string, AgencyBranding>;

export const getAgencyBranding = (agencyName?: string): AgencyBranding | undefined => {
  return agencyBranding[agencyName];
};
